var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolyUnselected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_323_11749)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 4,
    fill: "#DDDDDD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_323_11749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 21.4375C24.0481 21.4375 24.035 21.4416 24.0207 21.4416L22.4129 18.7625C22.6208 18.3863 22.75 17.9602 22.75 17.5C22.75 17.0398 22.6212 16.6137 22.4129 16.2375L24.0207 13.5584C24.035 13.5588 24.0481 13.5625 24.0625 13.5625C25.5124 13.5625 26.6875 12.3874 26.6875 10.9375C26.6875 9.4876 25.5124 8.3125 24.0625 8.3125C23.0933 8.3125 22.2562 8.84365 21.8017 9.625H13.1983C12.7438 8.84365 11.9067 8.3125 10.9375 8.3125C9.4876 8.3125 8.3125 9.4876 8.3125 10.9375C8.3125 11.9067 8.84365 12.7438 9.625 13.1983V21.8013C8.84365 22.2562 8.3125 23.0933 8.3125 24.0625C8.3125 25.5124 9.4876 26.6875 10.9375 26.6875C11.9067 26.6875 12.7438 26.1563 13.1983 25.375H21.8013C22.2562 26.1563 23.0929 26.6875 24.0621 26.6875C25.512 26.6875 26.6871 25.5124 26.6871 24.0625C26.6875 22.6126 25.5124 21.4375 24.0625 21.4375ZM12.25 21.8017V13.1983C12.6431 12.9699 12.9699 12.6431 13.1983 12.25H21.7443L20.1668 14.8791C20.1525 14.8787 20.1394 14.875 20.125 14.875C18.6751 14.875 17.5 16.0501 17.5 17.5C17.5 18.9499 18.6751 20.125 20.125 20.125C20.1394 20.125 20.1525 20.1209 20.1668 20.1209L21.7443 22.75H13.1983C12.97 22.3568 12.6432 22.03 12.25 21.8017ZM19.4688 17.5C19.4688 17.1382 19.7632 16.8438 20.125 16.8438C20.4868 16.8438 20.7812 17.1382 20.7812 17.5C20.7812 17.8618 20.4868 18.1562 20.125 18.1562C19.7632 18.1562 19.4688 17.8618 19.4688 17.5ZM24.7188 10.9375C24.7188 11.2993 24.4243 11.5938 24.0625 11.5938C23.7007 11.5938 23.4062 11.2993 23.4062 10.9375C23.4062 10.5757 23.7007 10.2812 24.0625 10.2812C24.4243 10.2812 24.7188 10.5757 24.7188 10.9375ZM10.9375 10.2812C11.2993 10.2812 11.5938 10.5757 11.5938 10.9375C11.5938 11.2993 11.2993 11.5938 10.9375 11.5938C10.5757 11.5938 10.2812 11.2993 10.2812 10.9375C10.2812 10.5757 10.5757 10.2812 10.9375 10.2812ZM10.2812 24.0625C10.2812 23.7007 10.5757 23.4062 10.9375 23.4062C11.2993 23.4062 11.5938 23.7007 11.5938 24.0625C11.5938 24.4243 11.2993 24.7188 10.9375 24.7188C10.5757 24.7188 10.2812 24.4243 10.2812 24.0625ZM24.0625 24.7188C23.7007 24.7188 23.4062 24.4243 23.4062 24.0625C23.4062 23.7007 23.7007 23.4062 24.0625 23.4062C24.4243 23.4062 24.7188 23.7007 24.7188 24.0625C24.7188 24.4243 24.4243 24.7188 24.0625 24.7188Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_323_11749",
    x: 0,
    y: 0,
    width: 35,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_323_11749"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_323_11749",
    x: 8.3125,
    y: 8.3125,
    width: 18.375,
    height: 19.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_323_11749"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyUnselected);
export default __webpack_public_path__ + "static/media/poly_unselected.8c1071a47297a4b19f7c1080f7be50e2.svg";
export { ForwardRef as ReactComponent };